import { Button } from '@iwoca/orion';

import LockSVG from '../../../assets/Lock.svg';
import { useSafeNavigate } from '../../../hooks/useSafeNavigate';

export const PermissionDenied = () => {
  const { navigate } = useSafeNavigate();

  return (
    <>
      <div className="mx-r mt-2xl">
        <img src={LockSVG} alt="A padlock" className="h-auto w-[72px]" />
        <h1 className="text-2xl font-bold">
          You’ll need to update your access level to do that
        </h1>
        <p className="text-m font-reg">
          Contact your iwocaPay admin or IT team to update your access
          level.{' '}
        </p>
        <Button
          onClick={() => navigate({ to: '/pay/dashboard' })}
          className="mt-xl"
        >
          Go to Dashboard
        </Button>
      </div>
    </>
  );
};
